import {
  AttendanceDashboardPeriod,
  periodToSearchParams
} from 'utils/attendanceDashboardPeriod';

export const buildManagerAttendanceListPath = (
  period?: AttendanceDashboardPeriod
): string => {
  if (!period) return '/manager/attendance';

  return `/manager/attendance?${periodToSearchParams(period).toString()}`;
};

export const buildManagerAttendanceDetailPath = (
  employeeId: string,
  period: AttendanceDashboardPeriod
): string =>
  `/manager/attendance/${encodeURIComponent(employeeId)}?${periodToSearchParams(period).toString()}`;

export const buildManagerAttendanceCalendarPath = (
  employeeId: string,
  period?: AttendanceDashboardPeriod
): string => {
  const base = `/manager/attendance/${encodeURIComponent(employeeId)}/calendar`;
  if (!period) return base;

  return `${base}?${periodToSearchParams(period).toString()}`;
};
